import { Routes, Route, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import Home from "./Home/index";
import Contact from "./Home/Contact";
import Preloader from "./Home/Preload";
import Liquidity from "./Liquidity Management/Index"
import Security from "./Security Risk/Index"
import Career from "./Career/Index";
import Assets from "./Asset Protection/Index"
import Client from "./Client Experience/Index"
import PrivacyPolicy from "./Condiation/Index";
import TermsConditions from "./Condiation/Termscondiation";
import Blog from "./Blog/index";
import BlogPage from "./Blog Details/index";
import ScrollToTop from "./Home/ScrollToTop";
import FAQSection from "./Home/FAQSection";
import Custody from "./Custody Platform/Index";
import Transaction from "./Transaction systems/Index";
import Securitygovernance from "./Security Governance/Index";

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  useEffect(() => {
  const isBot = /bot|crawl|spider/i.test(navigator.userAgent);

  if (isBot) {
    setLoading(false);
    return;
  }

  setLoading(true);

  const timer = setTimeout(() => {
    setLoading(false);
  }, 500);

  return () => clearTimeout(timer);
}, [location.pathname]);


  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={ <Home/> } />
          <Route path="/blog" element={ <Blog/> } />
          <Route path="/:slug" element={<BlogPage />} />
          <Route path="/liquidity-management" element={ <Liquidity/> } />
          <Route path="/security-risk" element={ <Security/> } />
          <Route path="/asset-protection" element={ <Assets/> } />
          <Route path="/custody-services" element={ <Custody/> } />
          <Route path="/transaction-systems" element={ <Transaction/> } />
          <Route path="/security-governance" element={ <Securitygovernance/> } />
          <Route path="/client-experience" element={ <Client/> } />
          <Route path="/privacy-policy" element={ <PrivacyPolicy/> } />
          <Route path="/terms-conditions" element={ <TermsConditions/> } />
          <Route path="/careers" element={ <Career/> } />
          <Route path="/contact-us" element={ <Contact/> } />
          <Route path="/faqs" element={ <FAQSection/> } />
        </Routes>
        </>
      )}
    </>

  )
}

export default App                  
